module.exports = __webpack_public_path__ + "img/base_nature_lac.ce00cbcb.svg";